import React, { useEffect, useState } from 'react';
import { useClearRefinements, useCurrentRefinements, useMenu } from 'react-instantsearch';
import { selectContainer, dropdownCustomChevron, disabledCursor } from './menu-select-widget.module.css';
import { searchClient, indexName } from '../../services/search-client';

const uniqBy = (items, property) => {
  const seen = {};

  return items.filter(item => {
    const val = item[property];

    if (seen[val]) {
      return false;
    } else {
      seen[val] = true;
      return true;
    }
  });
}

const MenuSelectWidget = ({ placeholder, attribute }) => {
  const { items, refine } = useMenu({ attribute });
  const [isDisabled, setDisabled] = useState(false);
  const [initialFacets, setInitialFacets] = useState([]);

  const { items: refinements } = useCurrentRefinements({ includedAttributes: ['desk'] });
  const { canRefine, refine: clearDeskCategory } = useClearRefinements({ includedAttributes: ['deskCategory'] })

  useEffect(() => {
    if (attribute === 'desk') {
      searchClient
        .searchForFacetValues([
          {
            indexName,
            params: {
              facetName: 'desk',
              facetQuery: '',
            },
          },
        ])
        .then(([{ facetHits }]) => {
          const facets = facetHits.map(facet => ({
            ...facet,
            label: facet.value,
            value: facet.value,
            isRefined: false,
            count: 0,
          }));
          setInitialFacets(facets);
        });
    }
  }, []);

  useEffect(() => {
    if (attribute === 'deskCategory') {
      const hasRefinements = refinements.length > 0 && refinements[0].refinements.length > 0;
      setDisabled(!hasRefinements);

      // Set dropdown to initial state
      if (canRefine && !hasRefinements) {
        clearDeskCategory()
      }
    }
  }, [refinements]);

  const combinedItems = attribute === 'desk' ? uniqBy([...items, ...initialFacets], 'label') : items;


  return (
    <select
      className={`${selectContainer} ${dropdownCustomChevron} ${isDisabled || combinedItems.length === 0 ? disabledCursor : ''}`}
      disabled={isDisabled || combinedItems.length === 0}
      defaultValue={''}
      onChange={(event) => {
        refine(event.target.value);
      }}
    >
      {placeholder && <option value=''>{placeholder}</option>}
      {combinedItems.map((item) => (
        <option key={item.value} value={item.value} selected={item.isRefined}>
          {item.label}
        </option>
      ))}
    </select>
  );
}

export default MenuSelectWidget;